import { TSellerProfileClient } from 'types/TSellerProfile';

import fetchAPI from '../utils/fetchAPI';

type TParams = {
  sellerId: number;
  requestExternalReviews?: boolean;
  showExtendedAsq?: boolean;
};

export default function getSellerProfile({
  sellerId,
  requestExternalReviews,
  showExtendedAsq,
}: TParams): Promise<TSellerProfileClient> {
  try {
    const query = new URLSearchParams();
    if (requestExternalReviews) {
      query.set('reviews', 'external');
    }
    if (showExtendedAsq) {
      query.set('asqType', 'extended');
    }
    return fetchAPI({
      url: `/v/api/seller-profile/${encodeURIComponent(sellerId)}${query.size ? `?${query.toString()}` : ''}`,
    });
  } catch {
    return Promise.resolve({}) as Promise<TSellerProfileClient>;
  }
}
